import { currentEnvironment, environmentMarkers } from '@/lib/environment';

/** SPEC-507: slim "Staging" marker (amber outline, not red). Renders nothing off staging.
 *  SPEC-510: a plain "Main site" link to production sits beside it. */
export function EnvironmentChip({ className = '' }: { className?: string }) {
  const { chip, mainSiteHref } = environmentMarkers(currentEnvironment());
  if (!chip) return null;
  return (
    <span className={`items-center ${className || 'inline-flex'}`}>
      <span
        data-testid="environment-chip"
        className="inline-flex items-center px-2 py-1 rounded-md text-[10px] font-semibold uppercase tracking-wider text-amber-400 border border-amber-500/60"
      >
        Staging
      </span>
      {mainSiteHref && (
        <a
          data-testid="main-site-link"
          href={mainSiteHref}
          rel="noopener"
          className="ml-2 text-xs text-[var(--text-secondary)] underline underline-offset-2 hover:text-[var(--text-primary)]"
        >
          Main site
        </a>
      )}
    </span>
  );
}
